import React from "react";
import formatRelativeTime from "./formatRelativeTime";
import "./PublicItemSocialPreview.css";

const stop = (event) => {
  event.preventDefault();
  event.stopPropagation();
};

function pluralizeComments(count) {
  return count === 1 ? "comment" : "comments";
}

export default function PublicItemSocialPreview({
  summary,
  onOpenItem,
  onOpenComments,
}) {
  const reactions = summary?.reactions || {};
  const comments = summary?.comments || {};
  const commentCount = Number(comments.count || 0);
  const latest = comments.latest || null;

  const openItem = (event) => {
    stop(event);
    onOpenItem?.();
  };

  const openComments = (event) => {
    stop(event);
    onOpenComments?.();
  };

  return (
    <div
      className="hub-social-preview"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="hub-social-preview-bar">
    {Number(reactions.love || 0) > 0 && (
      <button
        type="button"
        className="hub-social-proof-pill"
        onClick={openItem}
        title="View reactions"
      >
        <span aria-hidden="true">❤️</span>
        <span>{reactions.love}</span>
      </button>
    )}

    {Number(reactions.jealous || 0) > 0 && (
      <button
        type="button"
        className="hub-social-proof-pill"
        onClick={openItem}
        title="View reactions"
      >
        <span aria-hidden="true">🤤</span>
        <span>{reactions.jealous}</span>
      </button>
    )}

    {Number(reactions.fire || 0) > 0 && (
      <button
        type="button"
        className="hub-social-proof-pill"
        onClick={openItem}
        title="View reactions"
      >
        <span aria-hidden="true">🔥</span>
        <span>{reactions.fire}</span>
      </button>
    )}

    <button
      type="button"
      className={`hub-social-proof-pill hub-comment-pill ${
        commentCount > 0 ? "has-comments" : "empty-comments"
      }`}
      onClick={openComments}
      title={
        commentCount > 0
          ? `View ${commentCount} ${pluralizeComments(commentCount)}`
          : "Start the conversation"
      }
    >
      <span aria-hidden="true">💬</span>

      <span>
        {commentCount > 0
          ? commentCount
          : "Start the conversation"}
      </span>
    </button>
  </div>

  {latest && (
    <button
      type="button"
      className="hub-comment-preview"
      onClick={openComments}
      title="Open comments"
    >
      <span className="hub-comment-preview-head">
        <strong>
          {latest.displayName || "collector"}
        </strong>

        {latest.createdAt && (
          <span className="hub-comment-preview-time">
            {formatRelativeTime(latest.createdAt)}
          </span>
        )}
      </span>

      <span className="hub-comment-preview-text">
        {latest.text}
      </span>

      {commentCount > 1 && (
        <span className="hub-comment-preview-more">
          View all {commentCount} comments
        </span>
      )}
    </button>
  )}
    </div>
  );
}
